import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const uploadImage = async (file: File): Promise<string | null> => {
  try {
    console.log('Starting image upload...', { fileName: file.name, fileSize: file.size, fileType: file.type });

    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}-${Date.now()}.${fileExt}`;
    const filePath = `job-headers/${fileName}`;

    console.log('Upload path:', filePath);

    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('images')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      console.error('Error uploading image:', uploadError);
      console.error('Upload error details:', {
        message: uploadError.message,
        name: uploadError.name,
        error: uploadError
      });
      return null;
    }

    console.log('Upload successful:', uploadData);

    const { data } = supabase.storage
      .from('images')
      .getPublicUrl(filePath);

    console.log('Public URL:', data.publicUrl);

    return data.publicUrl;
  } catch (error) {
    console.error('Error in uploadImage:', error);
    return null;
  }
};